import { render, staticRenderFns } from "./HelloWorldScreen.vue?vue&type=template&id=1662bb9c&"
import script from "./HelloWorldScreen.vue?vue&type=script&lang=js&"
export * from "./HelloWorldScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
